import api from "../config/api";

export const getSalaries = async (data) => {
  const res = await api.post("salary/getSalaries", data);
  return res.data;
};

export const getSalaryByid = async (_id) => {
  const res = await api.get(`salary/${_id}`);
  return res.data;
};
